import { EventBus } from '@campus/core';
import { usePrimaryTouch } from '../hooks/useIsMobile.js';

/**
 * Calque tactile plein écran — tap ou drag pour déplacer l'avatar vers ce point
 * (comme un point-and-click). Émet les coordonnées écran brutes ; c'est ZoneScene
 * qui les convertit en coordonnées monde via la caméra (elle seule connaît le
 * zoom/scroll courant).
 *
 * Important : pas de z-index positif sur ce calque — voir App.tsx, il doit rester
 * au niveau "auto" et être placé en premier dans le DOM pour que le HUD, le chat
 * et les modals (rendus après lui) reçoivent bien les taps sur leurs propres zones.
 *
 * Seulement quand le doigt est le pointeur principal : ce calque recouvre la carte
 * et intercepte aussi la souris. Sur un portable Windows à écran tactile
 * (`maxTouchPoints > 0`, souris principale), il empêchait tout clic sur la carte,
 * dont la pose d'objets sur un bureau personnel (retours Copyhouse, 2026-10-20).
 */
export function TapToMove() {
  const isTouch = usePrimaryTouch();

  if (!isTouch) return null;

  function emitTarget(e: React.TouchEvent<HTMLDivElement>) {
    const touch = e.changedTouches[0];
    if (!touch) return;
    EventBus.emit('input:tap-move', { clientX: touch.clientX, clientY: touch.clientY });
  }

  return (
    <div
      onTouchStart={emitTarget}
      onTouchMove={emitTarget}
      style={{
        position: 'absolute',
        inset: 0,
        pointerEvents: 'auto',
        touchAction: 'none',
      }}
    />
  );
}
